import React, { useState, useEffect } from 'react';
import Image from '../../../components/atom/image';
import { Link } from 'react-router-dom';
import client from '../../../lib/crypto/client'
import TopJson from '../top.json';
import './shared.css';
import '../../../components/organism/thankyou/Confirmation.css';
import { useSelector, useDispatch } from 'react-redux';
import { getCartCount, cvlData, resetGuest, updateGuest } from '../../../redux/actions/trans/authAction';
import loginApi from '../../loginApi';
import ApiCall from '../../trans/trans';
import { useHistory } from "react-router-dom";
import { updateUrlDetailsForQuickInvest } from '../../../redux/actions/quickbuy';
import { getDecryptedItem, setEncryptedItem, checkPanAndSetStorage } from '../../../helper/methods';
import PasscodePopup from '../../../components/organism/thankyou/PasscodePopup';
import Cookie from '../../../lib/cookie';
import { regEx } from '../../../helper/constant';
import { createLog } from '../../../helper/logger';

let api = new loginApi();
let api2 = new ApiCall();
let cookie = new Cookie();
const Navbar = (props) => {
    const isFromBanner = localStorage.getItem('isFromBanner');
    const [navType, setNavType] = useState('');
    const [show, setShow] = useState(false);
    const [topKey, setTopKey] = useState('MF')
    const [PAN, setPAN] = useState('');
    const [ClientType, setClientType] = useState('');
    const [showbtn, setshowbtn] = useState(false);
    
    // Passcode popup states
    const [showPasscodePopup, setShowPasscodePopup] = useState(false);
    const [passcodeValue, setPasscodeValue] = useState('');
    const [passcodeError, setPasscodeError] = useState('');
    const [passcodeLoading, setPasscodeLoading] = useState(false);

    const dispatch = useDispatch()

    const stateData = useSelector(state => state.Auth);
    const history = useHistory();

    const navTypeClick = (data) => {
        if (navType === data) {
            setNavType('')
        } else {
            setNavType(data)
        }

    }


    const topHeading = (data) => {
        let { internal, filter, url } = data;
        if (PAN !== '') {
            let res = api.encrypt("panNo=" + PAN);
            let lastURL = url + '' + res;
            console.log(lastURL, 'lastURL')
            window.location.href = lastURL;
        }
    }

    const gotoResetPasscode = () => {
        let page_url = process.env.REACT_APP_MODE === "development" ? "/login/resetpasscode" : "/mutualfund/login/resetpasscode";
        window.location.href = page_url;
    }

    const handleLogout = () => {
        //localStorage.setItem("pageUrl", 'quickbuy');
        props.logout();
    }

    const handleShow = () => {
        setShow(!show)
    }

    const closePOpUp = () => {
        // setHit(hit?false:true)
        let getNavbar = document.querySelectorAll('.navbarTop .nav-item');
        console.log(getNavbar, 'getNavbar')
        getNavbar.forEach((curr) => {
            console.log(curr.childNodes, 'Sujeet')
            if (curr.childNodes[1] !== undefined) {
                curr.childNodes[1].classList.remove('show');
            }

            //  let checkClass= curr.getElementByClassName('.show');
            //console.log(checkClass,'checkClass')
        })


    }


    const redirectPurchasePage = () => {
        let urlParams = {
            singleAssetType: "All",
            fundCodeFromUrl: null,
            optionCodeFromUrl: null,
            planCodeFromUrl: null,
            isQuickInvestFromUrl: null,

            option: null,
            brokercode: null,
            subbrokercode: null,
            euinno: null,
            internalcode: null,
            utm_campaign: null,
        }
        dispatch(updateUrlDetailsForQuickInvest(urlParams));
        history.push("/quickbuy");
    }

    const redirectOurFundsPage = () => {
        window.location.href = `${process.env.REACT_APP_MOTILAL_MF_MODULE_URL}/mutual-funds`;
    }

    const handleMyPortfolioClick = () => {
        setShowPasscodePopup(true);
    }

    const handlePasscodeSubmit = () => {
        if (passcodeValue.length === 4 && PAN) {
            setPasscodeLoading(true);
            setPasscodeError('');
            
            let data = {
                "apiName": "authenticateUser",
                "addtoken": false,
                "body": {
                    "password": passcodeValue,
                    "userId": PAN,
                    "loginModeId": 1,
                    "credentialModeId": 3,
                    "ipV4": "192.198.22.22",
                    "otpThroughDIT": false,
                    "ditotpType": "",
                    "pmsGuest": false,
                    "isAIF": false,
                    "mfGuest": false,
                    "product": "MF"
                }
            }
            
            api.common(data).then(res => {
                setPasscodeLoading(false);
                
                if (res?.data?.success) {
                    createLog('Login_With_Code', { loginPage: 'Portfolio' });
                    createLog('login_completed');
                    
                    const userInfo = res?.data?.userInfo;
                    const userObj = {};
                    userObj.Identity = userInfo?.client_UCID;
                    userObj.Name = userInfo?.clientName;
                    userObj.Email = userInfo?.email;
                    userObj.panNo = userInfo?.paN_NO;
                    userObj.clientName = userInfo?.clientName;
                    userObj.clientType = userInfo?.clientType;
                    userObj.isIndividualPan = userInfo?.isIndividualPan;
                    userObj.nriFlag = userInfo?.nriFlag;
                    userObj["MSG-whatsapp"] = true;
                    
                    if (regEx?.indianMobileNumber.test(userInfo?.mobile) && userInfo?.mobile?.length === 10) {
                        userObj.Phone = '+91' + userInfo?.mobile;
                    } else if (regEx?.indianMobileNumber.test(userInfo?.mobile) && userInfo?.mobile?.length === 12) {
                        userObj.Phone = '+' + userInfo?.mobile;
                    } else {
                        userObj.Phone = userInfo?.mobile;
                    }
                    
                    setEncryptedItem('pendingSetUserObjEvent', userObj);
                    checkPanAndSetStorage(userInfo?.paN_NO, false);

                    let fromBanner = localStorage.getItem('isFromBanner');

                    if (fromBanner){

                        localStorage.removeItem('isFromBanner');

                    }
                    
                    setShowPasscodePopup(false);
                    setPasscodeError('');
                    setPasscodeValue('');
                    setPasscodeLoading(false);
                    
                    setTimeout(() => {
                        history.push('/portfolio');
                    }, 200);
                } else {
                    setPasscodeError(res?.data?.message || res?.message || 'Invalid passcode');
                    setPasscodeValue('');
                }
            }).catch((e) => {
                setPasscodeLoading(false);
                setPasscodeError('Authentication failed. Please try again.');
                setPasscodeValue('');
            });
        } else {
            setPasscodeError(passcodeValue.length === 0 ? 'Please enter passcode' : 'Please enter valid passcode');
        }
    }

    const handlePasscodeClose = () => {
        setShowPasscodePopup(false);
        setPasscodeValue('');
        setPasscodeError('');
        setPasscodeLoading(false);
    }

    const handleForgotPasscode = () => {
        history.push('/login/resetpasscode');
    }

    useEffect(() => {

        if (typeof window !== 'undefined') {
            // Check if coming from SSO redirect via URL parameter
            const urlParams = new URLSearchParams(window.location.search);
            const isFromSSO = urlParams.get('ssoRedirect') === 'true';

            async function setInitials() {
                // Wait for cookies only if coming from SSO
                if (isFromSSO) {
                    await new Promise(resolve => setTimeout(resolve, 300));
                }
                
                let clientTypeArr = localStorage.getItem('ClientType');
                let panNoArr = getDecryptedItem("uniqueKey");

                if (!panNoArr || !clientTypeArr) {
                    // Call PAN from Token.
                    // Call CVL API.
                    // Call ClientType API.
                    // Set localstorage.
                    let CustPAN = "";
                    let getPayload = {
                        apiName: "GetPanFromToken",
                        params: ""
                    }
                    let apiResponsePAN = await api2.commonGet(getPayload);
                    console.log("apiResponsePAN =========", apiResponsePAN);
                    if (apiResponsePAN?.data?.success === true) {
                        CustPAN = apiResponsePAN?.data?.data;
                        let CVLpayload = {
                            "apiName": "kycCheck",
                            "body": { panNo: CustPAN }
                        };
                        let kycResponse = await api.common(CVLpayload);

                        let payloadClientType = {
                            "apiName": "clientType",
                            "body": { panNo: CustPAN }
                        };
                        let clientTypeResponse = await api.common(payloadClientType);

                        localStorage.setItem('ClientType', JSON.stringify(clientTypeResponse?.data));
                        setEncryptedItem("uniqueKey", { panNo: CustPAN, nameAsOnPan: kycResponse?.data?.data?.nameAsOnPan });
                    }
                }

                // let panNoArr = getDecryptedItem("uniqueKey');
                if (panNoArr) {
                    let jsonData = panNoArr;
                    setPAN(jsonData.panNo);
                }
                // let clientTypeArr = localStorage.getItem('ClientType');
                if (clientTypeArr) {
                    let clientJsonData = JSON.parse(clientTypeArr);
                    setClientType(clientJsonData.data.existingClient);
                }
            }
            setInitials();

            var localData = getDecryptedItem("uniqueKey");
            if (localData) {
                var jsonData = localData;
                dispatch(cvlData({
                    pan: jsonData.panNo,
                    nameAsOnPan: jsonData.nameAsOnPan
                }))
            }
            var guestData = localStorage.getItem('isGuest');
            if (guestData) {
                var guestJsonData = JSON.parse(guestData);
            }
        }

        let getNavbar = document.querySelectorAll('.navbarTop .nav-item');

        const mouseOverListener = (curr, el) => {
            console.log(el.childNodes, 'el.childNodes', curr)
            if (el.childNodes[1] !== undefined) {
                el.childNodes[1].classList.add('show');
                el.classList.add('show');
            }
        }

        const mouseOutListener = (curr, el) => {
            console.log(el.childNodes, 'el.childNodesover', curr)
            if (el.childNodes[1] !== undefined) {
                el.childNodes[1].classList.remove('show');
                el.classList.remove('show');
            }
        }

        const mouseClickListener = (curr, el) => {
            console.log(el.childNodes, 'el.childNodesover', curr)
            if (el.childNodes[1] !== undefined) {
                el.childNodes[1].classList.remove('show');
                el.classList.remove('show');
            }
        }

        getNavbar.forEach((el) => {
            getNavbar.forEach((el) => {
                el.addEventListener('mouseover', (curr) => mouseOverListener(curr, el));
                el.addEventListener('mouseout', (curr) => mouseOutListener(curr, el));
                el.addEventListener('click', (curr) => mouseClickListener(curr, el));
            })
        })

        try {
            let panNo = stateData['cvlData']['pan'];

            dispatch(getCartCount({
                apiName: "GetCartCount",
                body: {
                    arnCode: "",
                    panNo: panNo,
                }
            }))
        } catch (error) { }

        return (() => {
            if (getNavbar) {
                getNavbar?.forEach?.((el) => {
                    el.removeEventListener('mouseover', (curr) => mouseOverListener(curr, el));
                    el.removeEventListener('mouseout', (curr) => mouseOutListener(curr, el));
                    el.removeEventListener('click', (curr) => mouseClickListener(curr, el));
                })
            }
        })
    }, [])


    const toggleOffcanvas = () => {
        document.querySelector('.sidebar-offcanvas').classList.toggle('active');
        document.querySelector('.button .navbar-toggler .navbar-toggler-right').classList.toggle('open');
    }


    var customerName = "";


    if (stateData['cvlData'] !== null) {
        customerName = stateData['cvlData']['nameAsOnPan'];
    }


    let pendingCount = 0;
    console.log("stateData['cartCountData']", stateData['cartCountData']);
    if (stateData['cartCountData'] !== null && stateData['cartCountData'] !== undefined) {
        if (stateData['cartCountData'].hasOwnProperty('pendingCount')) {
            pendingCount = stateData['cartCountData']['pendingCount'];
        }
    }




    // let ClientType = localStorage.getItem('ClientType');
    // let isBoth = true;
    // if(ClientType !== ''){
    //   let ClientTypeJson = JSON.parse(ClientType);
    //   console.log("ClientTypeJson", ClientTypeJson)
    //   if(ClientTypeJson!==null){    
    //     if(ClientTypeJson.success === true){
    //       if(ClientTypeJson.data.existingClient === "BOTH"){
    //         isBoth = true;
    //       }
    //     }        
    //   }
    // }
    useEffect(() => {
        if (ClientType !== "") {
            if (ClientType == "BOTH") {
                document.body.classList.add('clientType_body');
            }
        }
    }, [ClientType])


    console.log(isBoth, 'isBoth')


    let isBoth = false;
    if (ClientType == "BOTH") {
        isBoth = true;
    }


    //for showing My Portfolio Button
    let fromBanner = localStorage.getItem('isFromBanner') === 'true'
    const isQuickbuyPage = window.location.pathname.includes('/quickbuy')

    const fetchUserInfo = async (retryCount = 0) => {
        // Check if coming from SSO redirect via URL parameter
        const urlParams = new URLSearchParams(window.location.search);
        const isFromSSO = urlParams.get('ssoRedirect') === 'true';
        
        try {
            // Wait for cookies only if coming from SSO
            if (isFromSSO && retryCount === 0) {
                await new Promise(resolve => setTimeout(resolve, 500));
            }
            
            const response = await api.getUserInfo();
            const { success, data = {} } = response?.data || {};
            
            if (success && data) {
                console.log("UserInfo from API:", data);
                localStorage.removeItem("userInfo");
                setEncryptedItem("userInfo", data);
                dispatch(cvlData({
                    pan: data?.paN_NO,
                    nameAsOnPan: data?.clientName
                }))
                console.log("UserInfo stored successfully");
            } else {
                console.log("API call failed:", response);
                // Retry only if from SSO and within retry limit
                if (isFromSSO && retryCount < 3) {
                    console.log(`Retrying fetchUserInfo... Attempt ${retryCount + 1}`);
                    await new Promise(resolve => setTimeout(resolve, 1000));
                    return fetchUserInfo(retryCount + 1);
                }
            }
        } catch (error) {
            console.error("Error fetching user info:", error);
            // Retry only if from SSO and within retry limit
            if (isFromSSO && retryCount < 3) {
                console.log(`Retrying after error... Attempt ${retryCount + 1}`);
                await new Promise(resolve => setTimeout(resolve, 1000));
                return fetchUserInfo(retryCount + 1);
            }
        }
    }
    
    useEffect(() => {
        fetchUserInfo();
    }, [])

    return (
        <React.Fragment>
            <nav className="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row remove_navbar-height ">
                <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
                    {/* <a className="navbar-brand brand-logo" href="/mutualfund/quickbuy"> */}

                    <a className="navbar-brand brand-logo"
                        href={isFromBanner ? undefined : "/mutualfund/portfolio"} // Disable href when isFromBanner is true
                        onClick={(e) => {
                            if (isFromBanner) {
                                e.preventDefault(); // Prevent navigation
                            }
                        }}
                    >
                        <Image image="nav/mo_logo.png" alt="logo" style={{ marginTop: '8px' }} />
                    </a>
                    {/* <a className="navbar-brand brand-logo-mini" href="/mutualfund/quickbuy"> */}

                    <a className="navbar-brand brand-logo-mini"
                        href={isFromBanner ? undefined : "/mutualfund/portfolio"} // Disable href when isFromBanner is true 
                        onClick={(e) => {
                            if (isFromBanner) {
                                e.preventDefault(); // Prevent navigation
                            }
                        }}>
                        <Image image="nav/mf-m-min-logo.svg" alt="logo" />
                        {/* <img src="assets/images/logo-mini.svg" alt="logo" /> */}
                    </a>

                    {isFromBanner && isQuickbuyPage &&
                        <div className="text-center mt_38">
                            <button className="btn go_dashboard_topbtn" onClick={handleMyPortfolioClick}>My Portfolio</button>
                        </div>
                    }
                </div>
             
                {/* <div>View More Funds</div> */}
                <div className="navbar-menu-wrapper d-flex align-items-stretch">
                    <span ref={props.navbarViewMoreFundsRef} className={'navbar-view-funds-container'}>
                        {/* <button className="qbuy-btn view-more-funds">View More Funds</button> */}
                    </span>
                    {
                        props.showQuickInvest && !isFromBanner
                            ?
                            <button className="primary-blue-button" type="button" onClick={redirectPurchasePage}>
                                Quick Invest
                            </button>
                            :
                            null
                    }

                    {
                       props.showQuickInvest && isFromBanner
                            ?
                            <button className="primary-blue-button " type="button" onClick={redirectOurFundsPage}>
                                Our Funds
                            </button>
                            :
                            null
                    }

                    <ul className="navbar-nav navbar-nav-right navbarTop">


                        <li className="nav-item nav-profile dropdown">
                            <a className="nav-link dropdown-toggle quickyBuy" id="profileDropdown"
                                onClick={handleShow} data-toggle="dropdown" aria-expanded="false">
                                <div className="nav-profile-img" >
                                    <Image image="nav/profile-icon.png" alt="image" />
                                </div>
                                <div className="nav-profile-text">
                                    <p className="mb-1 text-black">{customerName}</p>
                                </div>
                            </a>
                            <div className={`dropdown-menu navbar-dropdown dropdown-menu-right p-0 border-0 font-size-sm ${show ? 'show' : ""}`} aria-labelledby="profileDropdown" data-x-placement="bottom-end">
                                <div className="p-2">


                                    <h5 className="dropdown-header text-uppercase  pl-2 text-dark mt-2">Actions</h5>
                                    {/* <a className="dropdown-item py-1 d-flex align-items-center justify-content-between" href="#">
              <span>Lock Account</span>
              <i className="mdi mdi-lock ml-1"></i>
            </a> */}
                                    <a onClick={gotoResetPasscode}
                                        className="dropdown-item py-1 d-flex align-items-center justify-content-between"
                                    >
                                        <span>Reset Passcode</span>
                                        <span className="p-0">
                                            <i className="mdi mdi-lock-reset ml-1"></i>
                                        </span>
                                    </a>
                                    <a className="dropdown-item py-1 d-flex align-items-center justify-content-between" onClick={handleLogout}>
                                        <span>Log Out</span>
                                        <i className="mdi mdi-logout ml-1"></i>
                                    </a>
                                </div>
                            </div>
                        </li>

                    </ul>

                </div>
            </nav>
          <PasscodePopup
                showPasscodePopup={showPasscodePopup}
                passcodeValue={passcodeValue}
                setPasscodeValue={setPasscodeValue}
                passcodeError={passcodeError}
                passcodeLoading={passcodeLoading}
                handlePasscodeClose={handlePasscodeClose}
                handlePasscodeSubmit={handlePasscodeSubmit}
                handleForgotPasscode={handleForgotPasscode}
            />
        </React.Fragment>
    )
}

export default Navbar